<template>
  <div class="withdraw-container">
    <div class="pc">
      <hm-content title :hidden="hidden">
        <div class>
          <div class="table-panel flex flex-between flex-wrap mb20 mt20">
            <div>
              <!-- <el-button type="primary" size="small" @click="batchAgree"
                >批量同意</el-button
              > -->
              <el-button type="primary" size="small" @click="batchCheck"
                >批量检查</el-button
              >
            </div>
            <div class="flex flex-wrap">
              <el-select
                size="small"
                clearable
                placeholder="导购黑名单状态"
                v-model="searchCondition.inWhiteList"
                class="mr10"
                style="width: 150px"
                filterable
              >
                <el-option
                  v-for="(item, i) in showBlacklist"
                  :key="i"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-select
                size="small"
                clearable
                placeholder="选择显示内部人员"
                v-model="searchCondition.showAgentUserName"
                class="mr10"
                style="width: 180px"
                filterable
              >
                <el-option
                  v-for="(item, i) in showAgentUserNameList"
                  :key="i"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-select
                size="small"
                clearable
                placeholder="选择状态"
                v-model="searchCondition.auditState"
                class="mr10"
                style="width: 120px"
                filterable
              >
                <el-option
                  v-for="(item, i) in statusList"
                  :key="i"
                  :label="item.name"
                  :value="item.objectId"
                ></el-option>
              </el-select>
              <el-date-picker
                :default-time="['00:00:00', '23:59:59']"
                class="mr10"
                size="small"
                value-format="yyyy-MM-dd HH:mm:ss"
                v-model="searchCondition.applyDate"
                type="datetimerange"
                range-separator="至"
                start-placeholder="申请开始日期"
                end-placeholder="申请结束日期"
              ></el-date-picker>
              <el-input
                clearable
                v-model.trim="searchCondition.keyWord"
                placeholder="输入提现单号/会员姓名/电话号码"
                size="small"
                style="width: 222px"
                class="ipt mr10"
              ></el-input>
              <div class="flex item-center input-range mr10">
                <el-input-number v-model="searchCondition.getcashStartMoney" size="small" :controls="false" placeholder="金额最小值" :min="0" clearable></el-input-number>
                <span class="m-x5">~</span>
                <el-input-number v-model="searchCondition.getcashEndMoney" size="small" :controls="false" placeholder="金额最大值" :min="0" clearable></el-input-number>
              </div>
            </div>            
          </div>
          <div class="flex flex-between mb10">
            <el-radio-group
              v-model="searchCondition.getcashType"
              size="small"
              @change="cashTypeTab"
            >
              <el-radio-button label="wechat">微信提现</el-radio-button>
              <el-radio-button label="bank">银行卡提现</el-radio-button>
              <el-radio-button label="alipay">支付宝提现</el-radio-button>
            </el-radio-group>
            <div class="flex flex-wrap">
              <el-button type="primary" size="small" @click="search"
                >查询</el-button
              >
              <!-- <el-button
                v-if="searchCondition.getcashType != 'wechat'"
                type="success"
                size="small"
                @click="output"
                :loading="isOutputing"
                >导出模板</el-button
              > -->
              <el-button
                v-if="searchCondition.getcashType == 'bank'"
                type="success"
                size="small"
                @click="outputBank"
                :loading="isOutputing"
                >导出银行卡提现</el-button
              >
              <el-button type="success" size="small" @click="outputDetail"
                >生成报表</el-button
              >
            </div>
          </div>
          <div class="table">
            <el-table
              stripe
              border
              ref="brandTable"
              @selection-change="getChecked"
              :data="cashOutList.records"
              style="width: 100%"
              id="table"
              size="small"
              v-if="resetForm"
              :height="tableHeight"
            >
              <el-table-column
                fixed
                type="selection"
                :selectable="checkboxT"
                width="40"
              ></el-table-column>
              <el-table-column
                type="index"
                label="序号"
                :index="(index) => index + (currentPage - 1) * pageSize + 1"
                fixed="left"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="orderSn"
                label="状态"
                fixed="left"
              >
                <template slot-scope="scope">
                  <span
                    class="status success"
                    :class="scope.row.status"
                    v-show="scope.row.auditState === 'agree'"
                    >通过</span
                  >
                  <span
                    class="status blue"
                    :class="scope.row.status"
                    v-show="scope.row.auditState === 'wait'"
                    >待审核</span
                  >
                  <span
                    class="status danger"
                    :class="scope.row.status"
                    v-show="scope.row.auditState === 'refuse'"
                    >驳回</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="getcashSn"
                label="提现单号"
                fixed="left"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="memberName"
                label="会员姓名"
                fixed="left"
              >
                <template slot-scope="scope">
                  <div>
                    {{ scope.row.memberName
                    }}<span v-if="scope.row.agentUserName"
                      >({{ scope.row.agentUserName }})</span
                    >
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                width="109"
                v-if="searchCondition.getcashType === 'alipay'"
                header-align="center"
                align="center"
                prop="receiveAccount"
                label="支付宝收款账号"
              ></el-table-column>
              
              
              <el-table-column
                header-align="center"
                align="center"
                prop="memberPhone"
                label="电话号码"
                fixed="left"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="getcashMoney"
                label="申请金额"
              >
                <template slot-scope="scope">
                  <div class="primary" v-if="scope.row.getcashMoney">
                    ¥{{ scope.row.getcashMoney }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="callbackOrderSn"
                label="支付回执单号"
              >
                <template slot-scope="scope">
                  <div
                    v-if="scope.row.getcashType === 'wechat_v3'"
                    class="blue"
                    @click="getWechatBatchStatus(scope.row)"
                  >
                    {{ scope.row.callbackOrderSn
                    }}<span v-if="scope.row.callbackOrderSn"
                      >(查看结算单状态)</span
                    >
                  </div>
                  <!-- <div
                    v-else-if="
                      scope.row.companyCode === 'FULU' ||
                      scope.row.companyCode === 'ZLB' ||
                      scope.row.companyCode === 'GZLLE' ||
                      scope.row.companyCode === 'DXG' ||
                      scope.row.companyCode === 'XYG'
                    "
                    class="blue"
                    @click="querySettlementRecord(scope.row)"
                  >
                    {{ scope.row.callbackOrderSn
                    }}<span v-if="scope.row.callbackOrderSn"
                      >(查看结算单状态)</span
                    >
                  </div>
                  <div v-else>
                    {{ scope.row.callbackOrderSn }}
                  </div> -->
                  <div
                    class="blue"
                    @click="querySettlementRecord(scope.row)"
                    v-if="scope.row.getcashType === 'bank'"
                  >
                    {{ scope.row.callbackOrderSn
                    }}<span v-if="scope.row.callbackOrderSn"
                      >(查看结算单状态)</span
                    >
                  </div>
                  <div
  class="blue"
  v-if="scope.row.getcashType === 'alipay'"
  @click.prevent="showNotice('当前不支持查询')"
>
  {{ scope.row.callbackOrderSn }}
  <span v-if="scope.row.callbackOrderSn">(当前不支持查询)</span>
</div>
                  <!-- <div
                    class="blue"
                    v-else
                  >
                    {{ scope.row.callbackOrderSn
                    }}<span v-if="scope.row.callbackOrderSn"
                      >(查看结算单状态)</span
                    >
                  </div> -->
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="callbackStatus"
                label="支付结果状态"
              >
                <template slot-scope="scope">
                  <div
                    v-if="scope.row.callbackStatus === 'success'"
                    class="success"
                  >
                    支付成功
                  </div>
                  <div
                    v-if="scope.row.callbackStatus === 'fail'"
                    class="danger"
                  >
                    支付失败
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="paymentStateDesc"
                label="结算单状态"
                v-if="searchCondition.getcashType === 'bank'"
              >
              </el-table-column>
              <el-table-column
                width="109"
                v-if="searchCondition.getcashType === 'wechat'"
                header-align="center"
                align="center"
                prop="alipayAccount"
                label="接口版本"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.getcashType === 'wechat'">微信</span>
                  <span v-else-if="scope.row.getcashType === 'wechat_v3'"
                    >微信V3</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                width="109"
                v-if="searchCondition.getcashType === 'bank'"
                header-align="center"
                align="center"
                prop="alipayAccount"
                label="银行卡号"
              >
                <template slot-scope="scope">
                  <span
                    v-if="
                      scope.row.sourceApp == 'WOYAOHEXIAO' && scope.row.bankInfo
                    "
                  >
                    {{ scope.row.bankInfo.bankCardNumber }}</span
                  >
                  <span v-else></span>
                </template>
              </el-table-column>
              <el-table-column
                width="109"
                v-if="searchCondition.getcashType === 'bank'"
                header-align="center"
                align="center"
                prop="alipayAccount"
                label="银行"
              >
                <template slot-scope="scope">
                  <span
                    v-if="
                      scope.row.sourceApp == 'WOYAOHEXIAO' && scope.row.bankInfo
                    "
                  >
                    {{ scope.row.bankInfo.bankName }}</span
                  >
                  <span v-else></span>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="relPreAccount"
                label="预发账户"
                v-if="searchCondition.getcashType !== 'wechat'"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="idcard"
                label="身份证号"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="getcachApplyTime"
                label="申请时间"
              ></el-table-column>
              
              <el-table-column
                header-align="center"
                align="center"
                prop="relPreAccount"
                label="预发账户"
                v-if="searchCondition.getcashType === 'wechat'"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="auditTime"
                label="审核时间"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="auditUsername"
                label="审核人"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="callbackMsg"
                label="支付结果信息"
                width="200"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="callbackReceiveAccount"
                label="付款账号"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="agreeRemark"
                label="打款备注"
                v-if="searchCondition.getcashType === 'bank'"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="refuseReason"
                label="驳回备注"
                width="200"
                :show-overflow-tooltip="true"
              >
                <!-- <template slot-scope="scope">
                  <el-tooltip
                    class="item"
                    :content="scope.row.refuseReason"
                    placement="top"
                  >
                  <div>
                     {{ scope.row.refuseReason }}
                  </div>

                  </el-tooltip>
                </template> -->
              </el-table-column>
              <!-- 已审核已驳回不显示 -->
              <el-table-column
                header-align="center"
                align="center"
                prop="orderSn"
                label="操作"
                width="200"
                fixed="right"
              >
                <template slot-scope="scope">
                  <div class="flex flex-center">
                    <el-button size="small" type="text" @click="bill(scope.row)"
                      >个人账单</el-button
                    >
                    <el-button
                      size="small"
                      type="text"
                      v-if="
                        searchCondition.getcashType === 'wechat' &&
                        scope.row.auditState === 'wait'
                      "
                      @click="details(scope.row)"
                      >查看</el-button
                    >
                    <!-- <el-button
                      size="small"
                      type="text"
                      @click="showRemark(scope.row)"
                      v-if="
                        scope.row.auditState === 'wait' &&
                        searchCondition.getcashType === 'bank' &&
                        scope.row.paymentStateDesc !== '拒绝发放' &&
                        scope.row.paymentStateDesc !== '打款失败' &&
                        scope.row.paymentStateDesc !== '打款中' &&
                        scope.row.paymentStateDesc !== '待打款'
                      "
                      >通过
                    </el-button>
                    <el-button
                      size="small"
                      type="text"
                      @click="audit(scope.row)"
                      v-else-if="
                        scope.row.auditState === 'wait' &&
                        searchCondition.getcashType !== 'bank'
                      "
                      >通过</el-button
                    >
                    <el-button
                      size="small"
                      type="text"
                      v-if="
                        scope.row.auditState === 'wait' &&
                        scope.row.paymentStateDesc !== '打款成功' &&
                        scope.row.paymentStateDesc !== '打款中' &&
                        scope.row.paymentStateDesc !== '待打款'
                      "
                      @click="reject(scope.row)"
                      >驳回</el-button
                    > -->
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <div class="hm-pagination">
              <el-pagination
                background
                :total="cashOutList.total"
                @current-change="paging"
                @size-change="handleSizeChange"
                layout="total,sizes,  prev, pager, next, jumper"
                :current-page="currentPage"
              ></el-pagination>
            </div>
          </div>
        </div>
        <el-dialog
          title="驳回备注"
          :close-on-click-modal="false"
          :visible.sync="dialogVisible"
          custom-class="sales-volumn-dialog"
        >
          <el-form
            label-width="80px"
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
          >
            <el-form-item label="驳回原因" prop="refuseReason">
              <el-input
                maxlength="100"
                placeholder="请输入驳回原因，可直接选择下方模板"
                size="small"
                style="width: auto"
                :autosize="{ minRows: 4 }"
                type="textarea"
                v-model="ruleForm.refuseReason"
              ></el-input>
            </el-form-item>
            <div class="reject-reason">
              <el-radio-group
                v-model="rejectReason"
                @change="switchRejectReason"
              >
                <div v-for="(v, i) in rejectTemp" :key="i">
                  <el-radio :label="i">{{ v }}</el-radio>
                </div>
              </el-radio-group>
            </div>
          </el-form>
          <span slot="footer" class="dialog-footer flex flex-center">
            <el-button
              @click="submitReject('ruleForm')"
              size="small"
              type="primary"
              >确认</el-button
            >
            <el-button @click="dialogVisible = false" size="small"
              >关闭</el-button
            >
          </span>
        </el-dialog>
        <el-dialog title="查看" :visible.sync="dialogVisibleDetails">
          <div class="wx-details">
            <div>交易时间：{{ wxDetails.transfer_time }}</div>
            <div>交易金额：{{ wxDetails.payment_amount }}</div>
            <div>交易单号：{{ wxDetails.detail_id }}</div>
          </div>
          <span slot="footer" class="dialog-footer flex flex-center">
            <el-button @click="updateWx" size="small" type="primary"
              >更 新</el-button
            >
            <el-button @click="dialogVisibleDetails = false" size="small"
              >关 闭</el-button
            >
          </span>
        </el-dialog>
      </hm-content>
    </div>
    <el-dialog
      :title="title"
      :close-on-click-modal="false"
      :visible.sync="dialogVisibleBill"
      width="75%"
    >
      <div class="mb20 guiderWhiteTips danger" v-if="guiderWhiteTips">
        {{ guiderWhiteTips }}
      </div>
      <el-radio-group v-model="type" size="small" @change="switchTab">
        <el-radio-button label="daoGou">导购账单</el-radio-button>
        <el-radio-button label="fenXiao">分销账单</el-radio-button>
        <el-radio-button label="withdraw">提现账单</el-radio-button>
        <el-radio-button label="recharge">充值账单</el-radio-button>
      </el-radio-group>
      <div class="modal-table mb20 mt10">
        <el-table stripe :data="[currentRow]" size="small" v-if="resetForm2">
          <el-table-column
            header-align="center"
            align="center"
            prop="memberName"
            label="姓名"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="memberPhone"
            label="电话"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="idcard"
            label="身份证号"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="storeName"
            label="所属商户"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="shopName"
            label="所属门店"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="allowGetcashMoneyAmount"
            label="可提现"
          >
            <template slot-scope="scope">
              {{ scope.row.allowGetcashMoneyAmount }}元
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="beingGetcashMoneyAmount"
            label="待发放"
          >
            <template slot-scope="scope">
              {{ scope.row.beingGetcashMoneyAmount }}元
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="hasGetcashMoneyAmount"
            label="已提现"
          >
            <template slot-scope="scope">
              {{ scope.row.hasGetcashMoneyAmount }}元
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div v-if="type === 'withdraw'">
        <!-- <div class="modal-table mb20 mt10">
          <div class="table-header flex mt10">
            <div class="flex-1">姓名</div>
            <div class="flex-1">电话</div>
            <div class="flex-1">身份证号</div>
          </div>
          <div class="table-body flex">
            <div class="flex-1">{{ currentRow.memberName }}</div>
            <div class="flex-1">{{ currentRow.memberPhone }}</div>
            <div class="flex-1">{{ currentRow.idcard }}</div>
          </div>
        </div> -->
        <div class="table-panel flex flex-end">
          <div class="flex-1 text-right">
            <el-input
              clearable
              style="width: 200px"
              v-model.trim="withdrawConditions.getcashSn"
              placeholder="请输入提现单号"
              size="small"
              class="ipt mr10"
            ></el-input>
            <el-date-picker
              v-model="withdrawConditions.getcachApplyTime"
              type="datetimerange"
              align="right"
              :default-time="['00:00:00', '23:59:59']"
              start-placeholder="选择申请时间段"
              end-placeholder="选择申请时间段"
              value-format="yyyy-MM-dd HH:mm:ss"
              size="small"
              class="mr10"
              clearable
            ></el-date-picker>
            <el-date-picker
              v-model="withdrawConditions.auditTime"
              type="datetimerange"
              align="right"
              :default-time="['00:00:00', '23:59:59']"
              start-placeholder="选择审核时间段"
              end-placeholder="选择审核时间段"
              value-format="yyyy-MM-dd HH:mm:ss"
              size="small"
              class="mr10"
              clearable
            ></el-date-picker>

            <el-button
              type="primary"
              size="small"
              @click="queryWithDrawOrderList(currentRow)"
              >查询</el-button
            >
            <!-- <el-button
              type="success"
              size="small"
              @click="output('queryAllWithDrawOrderList', '提现账单')"
              :loading="isOutputing"
              >导出</el-button
            > -->
          </div>
        </div>
        <div class="table">
          <el-table
            stripe
            border
            :data="widthDrawList"
            size="small"
            v-if="resetForm2"
          >
            <el-table-column
              header-align="center"
              align="center"
              prop="getcashSn"
              label="提现单号"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.getcashSn }}</span>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="getcachApplyTime"
              label="申请时间"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.getcachApplyTime }}</span>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="auditTime"
              label="审核时间"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.auditTime }}</span>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="auditUsername"
              label="审核人"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.auditUsername }}</span>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="发放渠道"
              prop="getcashType"
            >
              <template slot-scope="scope">
                <div
                  class="success"
                  v-if="scope.row.getcashType === 'wechat_v3'"
                >
                  微信V3
                </div>
                <div class="success" v-if="scope.row.getcashType === 'wechat'">
                  微信
                </div>
                <div
                  class="blue"
                  v-else-if="scope.row.getcashType === 'alipay'"
                >
                  支付宝
                </div>
                <div class="" v-else-if="scope.row.getcashType === 'bank'">
                  银行卡
                </div>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="提现金额"
            >
              <template slot-scope="scope">
                <span class="primary">￥{{ scope.row.getcashMoney }}</span>
              </template>
            </el-table-column>
          </el-table>

          <div class="hm-pagination">
            <el-pagination
              background
              :total="widthDrawListTotal"
              @current-change="withDrawpaging"
              @size-change="handleWithDrawSizeChange"
              layout="total,sizes,  prev, pager, next, jumper"
              :current-page="withdrawCurrentPage"
            ></el-pagination>
          </div>
        </div>
      </div>
      <div v-else-if="type === 'daoGou'">
        <hm-guider-bill
          ref="HmGuiderBill"
          :customerId="currentRow.customerId"
          @checkAll="checkAllEvent"
        ></hm-guider-bill>
        <div class="table-panel flex flex-end mt20" v-if="currentRow.guiderId">
          <div class="flex-1 text-right">
            <el-date-picker
              v-model="declareTime"
              type="datetimerange"
              align="right"
              :default-time="['00:00:00', '23:59:59']"
              start-placeholder="选择上传时间段"
              end-placeholder="选择上传时间段"
              value-format="yyyy-MM-dd HH:mm:ss"
              size="small"
              class="mr10"
              clearable
            ></el-date-picker>
            <el-button
              type="primary"
              size="small"
              @click="queryGuiderOrderList(currentRow)"
              >查询</el-button
            >
            <!-- <el-button
              type="success"
              size="small"
              @click="output('queryAllGuiderOrderList', '导购账单')"
              :loading="isOutputing"
              >导出</el-button
            > -->
          </div>
        </div>
        <div class="table" v-if="currentRow.guiderId">
          <el-table
            stripe
            border
            :data="guiderList"
            size="small"
            v-if="resetForm2"
          >
            <el-table-column
              header-align="center"
              align="center"
              prop="declareSn"
              label="申报单号"
            >
              <template slot-scope="scope">
                <div
                  class="blue pointer"
                  @click="viewDetails(scope.row.declareSn)"
                >
                  {{ scope.row.declareSn }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="receiptSn"
              label="小票号"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.receiptSn }}</span>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="declareTime"
              label="申报时间"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.declareTime }}</span>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="receiptTime"
              label="小票日期"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.receiptDate }}</span>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="personAuditUsername"
              label="审核人"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="goodsNum"
              label="销售商品数量"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.goodsNum }}</span>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="总计收益"
            >
              <template slot-scope="scope">
                <span class="primary">￥{{ scope.row.redpackageMoney }}</span>
              </template>
            </el-table-column>
            <!-- <el-table-column label="操作" header-align="center" align="center">
              <template slot-scope="scope">
                <div class="flex flex-center">
                  <el-button
                    size="small"
                    type="text"
                    @click="details(scope.row)"
                    >查看详情</el-button
                  >
                </div>
              </template>
            </el-table-column> -->
          </el-table>
          <div class="flex flex-end" style="fontsize: 15px">
            当前页面的总计收益:
            <span class="primary"> {{ ToFixed(currentTotal, 2) }}</span
            >元
          </div>

          <div class="hm-pagination">
            <el-pagination
              background
              :total="guiderListTotal"
              @current-change="guiderPaging"
              @size-change="handleGuiderSizeChange"
              layout="total,sizes,  prev, pager, next, jumper"
              :current-page="guiderCurrentPage"
            ></el-pagination>
          </div>
        </div>
        <div v-else class="mt10 danger">还不是导购!</div>
      </div>
      <div v-else-if="type === 'fenXiao'">
        <!-- <div class="modal-table mb20 mt10">
          <div class="table-header flex">
            <div class="flex-1">姓名</div>
            <div class="flex-1">电话</div>
            <div class="flex-1">身份证号</div>
          </div>
          <div class="table-body flex">
            <div class="flex-1">{{ currentRow.memberName }}</div>
            <div class="flex-1">{{ currentRow.memberPhone }}</div>
            <div class="flex-1">{{ currentRow.idcard }}</div>
          </div>
        </div> -->
        <div class="table-panel flex flex-end">
          <div class="flex-1 text-right">
            <el-date-picker
              v-model="unlockTime"
              type="datetimerange"
              align="right"
              :default-time="['00:00:00', '23:59:59']"
              start-placeholder="选择解锁时间段"
              end-placeholder="选择解锁时间段"
              value-format="yyyy-MM-dd HH:mm:ss"
              size="small"
              class="mr10"
              clearable
            ></el-date-picker>
            <el-button
              type="primary"
              size="small"
              @click="queryShareOrderList(currentRow)"
              >查询</el-button
            >
            <!-- <el-button
              type="success"
              size="small"
              @click="output('queryAllShareOrderList', '分销账单')"
              :loading="isOutputing"
              >导出账单</el-button
            > -->
          </div>
        </div>
        <div class="table">
          <el-table
            stripe
            border
            :data="shareList"
            size="small"
            v-if="resetForm2"
          >
            <el-table-column
              header-align="center"
              align="center"
              prop="receiptSn"
              label="订单号"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.receiptSn }}</span>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="payTime"
              label="付款日期"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.payTime }}</span>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="unlockTime"
              label="解锁日期"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.unlockTime }}</span>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="订单金额"
            >
              <template slot-scope="scope">
                <span class="primary">￥{{ scope.row.actuallyPrice }}</span>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="totalGoodsNum"
              label="订单商品数量"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.totalGoodsNum }}</span>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="storeName"
              label="所属商城"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.storeName }}</span>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="总计收益"
            >
              <template slot-scope="scope">
                <span class="primary">￥{{ scope.row.commissionPrice }}</span>
              </template>
            </el-table-column>
            <!-- <el-table-column label="操作" header-align="center" align="center">
              <template slot-scope="scope">
                <div class="flex flex-center">
                  <el-button size="small" type="text" @click="detail(scope.row)"
                    >查看详情</el-button
                  >
                </div>
              </template>
            </el-table-column> -->
          </el-table>

          <div class="hm-pagination">
            <el-pagination
              background
              :total="shareListTotal"
              @current-change="shareListPaging"
              @size-change="handleShareListSizeChange"
              layout="total,sizes,  prev, pager, next, jumper"
              :current-page="shareOrderPageNo"
            ></el-pagination>
          </div>
        </div>
      </div>
      <div v-else-if="type === 'recharge'">
        <el-table
          stripe
          border
          :data="rechargeList"
          size="small"
          v-if="resetForm2"
        >
          <el-table-column
            header-align="center"
            align="center"
            prop="rechargeSn"
            label="充值单号"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.rechargeSn }}</span>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="rechargeTime"
            label="充值时间"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.rechargeTime }}</span>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="rechargeMoney"
            label="充值金额"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.rechargeMoney }}</span>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="充值状态"
          >
            <template slot-scope="scope">
              <span
                :class="
                  scope.row.rechargeState === 'yes' ? 'success' : 'danger'
                "
                >{{ scope.row.rechargeState === "yes" ? "成功" : "失败" }}</span
              >
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="rechargeBeforeBalance"
            label="充值前金额"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.rechargeBeforeBalance }}</span>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="rechargeAfterBalance"
            label="充值后金额"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.rechargeAfterBalance }}</span>
            </template>
          </el-table-column>
        </el-table>

        <div class="hm-pagination">
          <el-pagination
            background
            :total="rechargeListTotal"
            @current-change="rechargeListPaging"
            @size-change="handleRechargeListSizeChange"
            layout="total,sizes,  prev, pager, next, jumper"
            :current-page="rechargePageNo"
          ></el-pagination>
        </div>
      </div>
      <span slot="footer" class="dialog-footer flex flex-center">        
        <el-button
          size="medium"
          type="primary"
          @click="showRemark(currentRow)"
          v-if="
            currentRow.auditState === 'wait' &&
            searchCondition.getcashType === 'bank' &&
            currentRow.paymentStateDesc !== '拒绝发放' &&
            currentRow.paymentStateDesc !== '打款失败' &&
            currentRow.paymentStateDesc !== '打款中' &&
            currentRow.paymentStateDesc !== '待打款'
          "
          :disabled="!checkAll"
          >通 过
        </el-button>
        <el-button
          size="medium"
          type="primary"
          @click="audit(currentRow)"
          v-else-if="
            currentRow.auditState === 'wait' &&
            searchCondition.getcashType !== 'bank'
          "
          :disabled="!checkAll"
          >通过</el-button
        >
        <el-button
          size="medium"
          v-if="
            currentRow.auditState === 'wait' &&
            currentRow.paymentStateDesc !== '打款成功' &&
            currentRow.paymentStateDesc !== '打款中' &&
            currentRow.paymentStateDesc !== '待打款'
          "
          @click="reject(currentRow)"
          >驳回</el-button
        >
      </span>

    </el-dialog>
    <div class="mobile">
      <div class="tabs flex flex-between">
        <div
          @click="switchTab(i)"
          class="tab"
          :class="{ active: activeTab === i }"
          v-for="(v, i) in tabList"
          :key="i"
        >
          {{ v.name }}
        </div>
      </div>
      <div class="scroll-content">
        <div class="control-panel flex">
          <div class="ipt-wrapper flex-1 flex item-center">
            <span class="icon hmicon icon-search"></span>
            <form @submit="search">
              <input
                type="search"
                ref="ipt"
                class="flex-1"
                placeholder="请输入导购名称/电话/单号"
                v-model="keywords"
              />
            </form>
          </div>
          <el-date-picker
            v-model="searchCondition.date"
            type="daterange"
            align="right"
            start-placeholder="申报开始时间"
            end-placeholder="申报结束时间"
            value-format="yyyy-MM-dd"
            size="small"
            class="mr10"
          ></el-date-picker>
        </div>
        <ul class="list">
          <li
            v-infinite-scroll="load"
            class="list-item"
            @click="toDetails(v)"
            v-for="(v, i) in mobileList"
            :key="i"
          >
            <div class="flex flex-between item-center">
              <div class="flex item-center">
                <div class="tag">申报单号</div>
                <div class="user-info flex-1">{{ v.orderNo }}</div>
              </div>
              <div>
                提现金额：
                <span class="price">￥{{ v.price }}</span>
              </div>
            </div>
            <div class="info">
              <div>
                <span class="date gray">导购姓名：{{ v.guideName }}</span>
              </div>
              <div>
                <span class="date gray">申报日期：{{ v.date }}</span>
              </div>
            </div>
          </li>
        </ul>
        <p v-if="loading">加载中...</p>
        <p v-if="noMore">没有更多了</p>
      </div>
    </div>
    <el-dialog
      title="确认打款"
      :close-on-click-modal="false"
      :visible.sync="dialogVisibleRemark"
      width="800px"
      @close="cancelDialogVisibleRemark"
    >
      <el-form
        :model="ruleFormRemark"
        :rules="rulesRemark"
        ref="ruleFormRemark"
        label-width="100px"
        size="small"
      >
      <template v-if="!handleBatch">
        <el-form-item label="提现单号">
          {{ currentRow.getcashSn }}
        </el-form-item>
        <el-form-item label="会员姓名">
          {{ currentRow.memberName}}<span v-if="currentRow.agentUserName">({{ currentRow.agentUserName }})</span>
        </el-form-item>
        <el-form-item label="银行">
          <span v-if="currentRow.sourceApp == 'WOYAOHEXIAO' && currentRow.bankInfo">
            {{ currentRow.bankInfo.bankName }}</span>
          <span v-else></span>
        </el-form-item>
        <el-form-item label="银行卡号">
          <span v-if="currentRow.sourceApp == 'WOYAOHEXIAO' && currentRow.bankInfo">{{ currentRow.bankInfo.bankCardNumber }}</span>
          <span v-else>-</span>
        </el-form-item>
        <el-form-item label="申请金额">
          <span class="primary" v-if="currentRow.getcashMoney">
            ¥{{ currentRow.getcashMoney }}
          </span>
        </el-form-item>
      </template>
        <el-form-item class="mb10" label="付款账号:" prop="paymentAccount">
          <el-select
            size="small"
            clearable
            class="mr10"
            placeholder="账号类型"
            v-model="ruleFormRemark.paymentAccount"
            style="width: 370px"
            filterable
            @change="paymentAccountChange"
          >
            <el-option
              v-for="(item, i) in bankCardList"
              :key="i"
              :label="item.sendName"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-button
            type="primary"
            size="small"
            @click="uploadWorkPlan(companyCode)"
            v-if="
              currentRowBankCard.procSettlementMode === 'yes'
            "
            >发起结算单</el-button
          >
          <el-button
            type="primary"
            size="small"
            @click="showForm2"
            v-if="
              currentRowBankCard.procRegisterMode === 'yes'
            "
            >注册</el-button
          >
          <div
            class="form-tips"
            v-if="
              ruleFormRemark.paymentAccount &&
              paymentAccountRow &&
              paymentAccountRow !== ruleFormRemark.paymentAccount
            "
          >
            打款账号已由【{{ paymentAccountSendNameRow }}】重新变更为【{{
              paymentAccountSendName
            }}】
          </div>
        </el-form-item>
        <el-form-item label="打款凭证：" prop="agreeCert">
          <el-upload
            v-show="spuSlideShowPicList.length < 5"
            class="upload flex"
            ref="elupload"
            :limit="5"
            drag
            multiple
            :data="{ fileDir: 'mall' }"
            :headers="{ 'X-Access-Token': $token }"
            :action="$uploadUrl"
            :on-remove="handleRemoves"
            :onError="uploadError"
            :onSuccess="cropUploadSuccesss"
            :beforeUpload="beforeAvatarUpload"
            :onProgress="uploading"
            :show-file-list="uploadShow"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将图片拖到此处，或
              <em>点击上传</em>
            </div>
            <div class="el-upload__tip" slot="tip">
              <div class="ml10">最多上传5张图片</div>
            </div>
          </el-upload>
          <draggable :list="spuSlideShowPicList" class="flex flex-wrap">
            <div
              class="priview mr10"
              v-show="v"
              v-for="(v, i) in spuSlideShowPicList"
              :key="i"
            >
              <!-- <img :src="v" alt="列表详情图" /> -->
              <el-image
                style="height: 100%; width: 100%"
                :src="v"
                v-if="v.indexOf('.mp4') === -1 && v.indexOf('.MP4') === -1"
                :preview-src-list="spuSlideShowPicList"
              ></el-image>
              <video class="video" controls :src="v" v-else></video>
              <div class="opreat-wrapper flex item-center flex-center">
                <el-button type="text" @click="handleRemoveListDetail(i)"
                  >删除</el-button
                >
              </div>
            </div>
          </draggable>
        </el-form-item>
        <el-form-item label="打款备注:">
          <el-input
            size="small"
            v-model="ruleFormRemark.agreeRemark"
            type="textarea"
            placeholder="请输入打款备注"
            style="width: 380px"
            :rows="4"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="flex flex-center">
        <el-button
          type="primary"
          size="small"
          @click="submitForm('ruleFormRemark')"
          v-if="!isBtn('agreeBtn:true') && currentRowBankCard.procRegisterMode !== 'yes'"
          >确定</el-button
        >
        <el-button size="small" @click="dialogVisibleRemark = false"
          >取消</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="提示"
      :close-on-click-modal="false"
      :visible.sync="dialogVisibleTips"
      width="800px"
    >
      <div>
        {{ currentRow.memberName }}({{
          currentRow.memberPhone
        }})有以下更早的单待审核，请按先审核以下单
      </div>
      <div>
        <el-table
          stripe
          border
          ref="tipsTable"
          :data="tipsTableList"
          style="width: 100%"
          size="small"
          class="mt20"
        >
          <el-table-column
            type="index"
            label="序号"
            :index="(index) => index + (currentPage - 1) * pageSize + 1"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="getcashSn"
            label="提现单号"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="createTime"
            label="申报时间"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="getcashType"
            label="提现方式"
          >
            <template slot-scope="scope">
              <span class="status" v-show="scope.row.getcashType === 'wechat'"
                >微信</span
              >
              <span class="status" v-show="scope.row.getcashType === 'alipay'"
                >支付宝</span
              >
              <span class="status" v-show="scope.row.getcashType === 'bank'"
                >银行卡</span
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="flex flex-center mt20">
        <el-button
          type="primary"
          size="small"
          @click="dialogVisibleTips = false"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="结算单状态"
      :close-on-click-modal="false"
      :visible.sync="dialogVisibleStatements"
      width="600px"
    >
      <div class="flex statements-item">
        <div>禾苗结算单号：</div>
        <div>{{ currentRow.hemiaoSettlementSn }}</div>
      </div>
      <div class="flex statements-item">
        <div>结算单号：</div>
        <div>{{ currentRow.callbackOrderSn }}</div>
      </div>
      <div class="flex statements-item">
        <div>结算渠道：</div>
        <div>{{ currentRow.companyName }}</div>
      </div>
      <div class="flex statements-item">
        <div>结算状态：</div>
        <div>{{ payStateDesc }}</div>
      </div>
      <div class="flex statements-item" v-if="payFailReason">
        <div>失败原因：</div>
        <div class="danger flex-1">{{ payFailReason }}</div>
      </div>
      <div class="flex flex-center mt20">
        <el-button
          type="primary"
          size="small"
          @click="dialogVisibleStatements = false"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="输入验证码"
      :close-on-click-modal="false"
      :visible.sync="dialogVisibleSmsCode"
      width="400px"
    >
      <div>
        <el-input
          clearable
          v-model.trim="smsCode"
          placeholder="输入验证码"
          maxlength="6"
          size="small"
          style="width: 200px"
          class="ipt mr10"
          @input="filterGt0OrFixed0('smsCode')"
        ></el-input>
        <el-button
          type="primary"
          size="small"
          @click="smsCodeSubmit"
          v-if="!regainState"
          >发送</el-button
        >
        <el-button
          type="primary"
          size="small"
          @click="smsCodeRegain"
          :disabled="smsCodeRegainState"
          v-if="regainState"
          >重新获取</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      :title="title2"
      :close-on-click-modal="false"
      :visible.sync="docheckDialogVisible"
    >
      <div class="flex flex-center danger mb20">注册签约时，需要验证身份证，实名，银行卡等信息，处理较慢，请耐心等待，注册签约完成！</div>
      <el-form
        :model="ruleForm2"
        ref="ruleForm2"
        label-width="200px"
        :rules="rules2"
      >
        <el-form-item label="签约公司:" prop="companyName">
          {{ruleForm2.companyName}}
        </el-form-item>

        <el-form-item label="签约人:" prop="idcardName">
          {{ruleForm2.idcardName}}
        </el-form-item>

        <el-form-item label="签约人手机号:" prop="authMobile">
          {{ruleForm2.authMobile}}
        </el-form-item>

        <el-form-item label="银行卡列表:" prop="bankRelId">
          <el-select
            size="small"
            clearable
            placeholder="银行卡列表"
            v-model="ruleForm2.bankRelId"
            class="mr10"
            filterable
            style="width:400px"
          >
            <el-option
              v-for="(item, i) in ruleForm2.bankRelList"
              :key="i"
              :label="item.bankName + '(' +item.bankCardNumber + ')'"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <div class="flex flex-center">
          <el-button type="primary" size="small" @click="submitForm2('ruleForm2')" :disabled="submitState"
            >提交</el-button
          >
          <el-button size="small" @click="cancel2">取消</el-button>
        </div>
      </el-form>
    </el-dialog>

    <el-dialog
      :visible.sync='batchCheckVisible'
      :close-on-click-modal='false'
      :close-on-press-escape='false'
      destroy-on-close
      custom-class='common-dialog'
      @close="batchCheckList=[],handleBatch=false"
      width="60%"
    >
    <span slot="title">
      <div class="flex item-center">
        <div>批量检查</div>
        <div class="ml20" v-if="searchCondition.getcashType == 'bank'">
          <span>付款账号：</span>
          <el-select
            size="small"
            clearable
            class="mr10"
            placeholder="账号类型"
            v-model="dialogVisiblePaymentAccount"
            style="width: 370px"
            filterable
            @change="dialogPaymentAccountChange"
          >
            <el-option
              v-for="(item, i) in dialogVisibleCardList"
              :key="i"
              :label="item.sendName"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
      </div>
  </span>
    <div class="total-result">已选择<span class="primary">{{ batchCheckList.length }}</span>条，总计<span class="primary">{{ batchCheckTotal }}</span>元</div>
      <el-table ref="batchCheckTable" :max-height="800" :data="batchCheckTableData" @selection-change="handleBatchCheckSelectionChange" @row-click="handleRowClick">
        <el-table-column
          type="selection"
          width="55"
          :selectable="(row, index) => selectableFn(row, index)"
        >
        </el-table-column>
        <el-table-column
          label="提现单号"
          header-align="center"
              align="center"
              prop="getcashSn">
        </el-table-column>
        <el-table-column
              header-align="center"
              align="center"
              prop="memberName"
              label="会员姓名"
        >
          <template slot-scope="scope">
            <div>
              {{ scope.row.memberName
              }}<span v-if="scope.row.agentUserName"
                >({{ scope.row.agentUserName }})</span
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="memberPhone"
          label="电话号码"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="getcashMoney"
          label="申请金额"
        >
          <template slot-scope="scope">
            <div class="primary" v-if="scope.row.getcashMoney">
              ¥{{ scope.row.getcashMoney }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="checkAll"
          label="风控检测状态"
        >
        <template slot-scope="scope">
          <!-- {{ scope.row.checkAll }} -->
          <el-tag type="success" v-if="scope.row.checkAll">风控检测通过</el-tag>
          <el-tag type="error" v-else>风控检测未通过</el-tag>
        </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="注册/结算"
          v-if="searchCondition.getcashType == 'bank'"
        >
        <template slot-scope="scope">
          <!-- {{ scope.row.checkAll }} -->
          <el-tag type="error" v-if="scope.row.isRegister">未注册</el-tag>
          <el-tag type="success" v-else>已注册</el-tag>
        </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="checkAll"
          label="操作"
          v-if="searchCondition.getcashType === 'bank'"
        >
        <template slot-scope="scope">
          <el-button type="text" v-if="selectableFn(scope.row)" @click="showRemark(scope.row, scope.$index)">通过</el-button>
          <el-button
          type="text"
          v-if="
            scope.row.auditState === 'wait' &&
            scope.row.paymentStateDesc !== '打款成功' &&
            scope.row.paymentStateDesc !== '打款中' &&
            scope.row.paymentStateDesc !== '待打款'
          "
          @click="reject(scope.row, scope.$index)"
          >驳回</el-button
        >
        </template>
        </el-table-column>
      </el-table>
      <template slot='footer'>
        <!-- <el-button @click='batchCheckVisible = false' type='primary' size='small'>确定</el-button> -->
        <el-button @click="handleBatchPass" type="primary">批量通过</el-button>
        <!-- <el-button>批量驳回</el-button> -->
      </template>
    </el-dialog>
  </div>
</template>

<script>
import myUpload from "vue-image-crop-upload";
import { ToFixed } from "@/utils/utils";
import { mapGetters } from "vuex";
import HmGuiderBill from "@/components/HmGuiderBill";
export default {
  components: { myUpload, HmGuiderBill },
  data() {
    return {
      ToFixed,
      rechargePageSize: 10,
      rechargePageNo: 1,
      rechargeListTotal: 0,
      rechargeList: [],
      hidden: true,
      wxDetails: {},
      dialogVisibleDetails: false,
      loading: false,
      noMore: false,
      checkedRow: [],
      activeTab: 0,
      keywords: "",
      status: "",
      widthDrawList: [],
      widthDrawListTotal: 0,
      statusList: [
        {
          name: "通过",
          objectId: "agree",
        },
        {
          name: "驳回",
          objectId: "refuse",
        },
        {
          name: "待审核",
          objectId: "wait",
        },
      ],
      tabList: [
        {
          name: "待审核",
        },
        {
          name: "已审核",
        },
        {
          name: "已驳回",
        },
      ],
      auditState: "agreen",
      rejectReason: "",
      reason: "",
      dialogVisible: false,
      dialogVisibleBill: false,
      type: "daoGou",
      ruleForm: {
        refuseReason: "",
      },
      rules: {
        refuseReason: {
          required: true,
          message: "请输入驳回原因",
          trigger: "change",
        },
      },
      rows: {},
      isOutputing: false,
      list: [
        {
          orderSn: "6125615514",
          income: 548,
          status: "audit_pass",
        },
      ],
      searchCondition: {
        getcashType: "wechat",
        auditState: "wait",
        showAgentUserName: "no",
        inWhiteList: "yes",
        getcashStartMoney: undefined,
        getcashEndMoney: undefined,
      },
      withdrawConditions: {},
      unlockTime: [],
      title: "",
      guiderList: [],
      guiderListTotal: 0,
      declareTime: [],
      total: 10,
      currentPage: 1,
      pageSize: 10,
      shareOrderPageSize: 10,
      shareOrderPageNo: 1,
      guiderCurrentPage: 1,
      guiderPageSize: 10,
      withdrawPageSize: 10,
      withdrawCurrentPage: 1,
      shareList: [],
      shareListTotal: 0,
      rejectTemp: [],
      tabPosition: "all",
      mobileList: [],
      currentRow: {},
      currentTotal: 0,
      ruleFormRemark: {
        paymentAccount: "",
        agreeCert: "",
        agreeRemark: "",
      },
      dialogVisibleRemark: false,
      spuSlideShowPicList: [],
      uploadShow: true,
      bankCardList: [],
      rulesRemark: {
        paymentAccount: {
          required: true,
          message: "请选择付款账号",
        },
      },
      paymentAccountRow: "",
      paymentAccountSendName: "",
      paymentAccountSendNameRow: "",
      resetForm: true,
      resetForm2: true,
      dialogVisibleTips: false,
      tipsTableList: [],
      companyCode: "",
      contractCompanyId: "",
      mchConfigId: "",
      dialogVisibleStatements: false,
      payStateDesc: "",
      payFailReason: "",
      guiderWhiteTips: "",
      showBlacklist: [
        {
          label: "黑名单导购",
          value: "no",
        },
        {
          label: "白名单导购",
          value: "yes",
        },
      ],
      showAgentUserNameList: [
        {
          label: "显示公司内部人员",
          value: "yes",
        },
        {
          label: "不显示公司内部人员",
          value: "no",
        },
      ],
      dialogVisibleSmsCode: false,
      smsCode: "",
      regainState: false,
      registerState: "",
      title2: "手动签约",
      docheckDialogVisible: false,
      ruleForm2: {},
      rules2: {},
      bankRelList: [],
      companyName: "",
      currentRowBankCard: {},
      submitState: false,
      smsCodeRegainState: false,
      checkAll: undefined,
      batchCheckVisible: false,
      batchCheckTableData: [],
      batchCheckList: [],
      rowIndex: null,
      tableHeight: "auto",
      handleBatch: false,
      dialogVisibleCardList: [],
      dialogVisiblePaymentAccount:''
    };
  },
  computed: {
    disabled() {
      return this.loading || this.noMore;
    },
    ...mapGetters(["cashOutList"]),
    batchCheckTotal() {
      let val = 0;
      this.batchCheckList.forEach((v) => {
        val += parseFloat(v.getcashMoney);
      });
      return val;
    },
  },
  watch: {},
  created() {
    this.queryList();
    this.queryDict();
  },
  mounted() {
    const tableDom = document.querySelector(".table");
    let h = tableDom.offsetTop + 200;
    this.tableHeight = `calc(100vh - ${h}px)`;
    this.resetForm = false;
    this.$nextTick(() => {
      this.resetForm = true;
    });
  },
  methods: {
    viewDetails(declareSn) {
      let routeData = this.$router.resolve({
        name: "DetailsSalesVolumeNew",
        query: { declareSn },
      });
      window.open(routeData.href, "_blank");
    },
    // tab切换
    cashTypeTab() {
      this.resetForm = false;
      this.batchCheckList = [];
      this.batchCheckTableData = [];
      this.checkedRow = [];
      this.$nextTick(() => {
        this.resetForm = true;
      });
      this.currentPage = 1;
      this.queryList();
    },
    async queryDict() {
      const { result } = await this.$store.dispatch("queryDict", {
        textCode: "getcash_audit_manual_template",
      });
      this.rejectTemp = result.textContentZhCn.split("|");
    },
    checkboxT(row) {
      if (row.auditState === "wait") {
        return true;
      } else {
        return false;
      }
    },
    switchRejectReason() {
      this.ruleForm.refuseReason = this.rejectTemp[this.rejectReason];
    },
    reject(row, index) {
      this.rowIndex = index;
      this.dialogVisible = true;
      this.rows = row;
    },
    switchTab(val) {
      this.resetForm2 = false;
      this.$nextTick(() => {
        this.resetForm2 = true;
      });
      if (val === "daoGou") {
        this.queryGuiderOrderList(this.currentRow);
      } else if (val === "fenXiao") {
        this.queryShareOrderList(this.currentRow);
      } else if (val === "withdraw") {
        this.queryWithDrawOrderList(this.currentRow);
      } else if (val === "recharge") {
        this.queryRechargeList(this.currentRow);
      }
    },
    async queryGuiderOrderList(row) {
      const { result } = await this.$store.dispatch("queryGuiderOrderList", {
        guiderId: row.guiderId,
        auditState: "agree",
        pageSize: this.guiderPageSize,
        pageNo: this.guiderCurrentPage,
        declareStartTime:
          this.declareTime && this.declareTime.length
            ? this.declareTime[0]
            : "",
        declareEndTime:
          this.declareTime && this.declareTime.length
            ? this.declareTime[1]
            : "",
      });
      const { records, total } = result;
      this.guiderList = records;
      let currentTotal = 0;
      this.guiderList.forEach((v) => {
        currentTotal += v.redpackageMoney;
      });
      this.currentTotal = currentTotal;
      this.guiderListTotal = total;
    },
    async queryShareOrderList(row) {
      const { result } = await this.$store.dispatch("queryShareOrderList", {
        customerId: row.customerId,
        pageSize: this.shareOrderPageSize,
        pageNo: this.shareOrderPageNo,
        unlockStartTime: this.unlockTime ? this.unlockTime[0] : "",
        unlockEndTime: this.unlockTime ? this.unlockTime[1] : "",
      });
      const { records, total } = result;
      this.shareList = records;
      this.shareListTotal = total;
    },
    async queryRechargeList() {
      const { result } = await this.$store.dispatch("guiderRechargeRecord", {
        customerId: this.currentRow.customerId,
        pageSize: this.rechargePageSize,
        pageNo: this.rechargePageNo,
      });
      const { records, total } = result;
      this.rechargeList = records;
      this.rechargeListTotal = total;
    },
    search() {
      if (
        this.searchCondition.getcashStartMoney >
        this.searchCondition.getcashEndMoney
      ) {
        this.$message({
          message: "金额最小值不能大于金额最大值！",
          type: "warning",
        });
        return false;
      }
      this.resetForm = false;
      this.$nextTick(() => {
        this.resetForm = true;
      });
      this.currentPage = 1;
      this.queryList();
    },
    outputDetail() {
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.starTime =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[0]
          : "";
      searchCondition.endTime =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[1]
          : "";

      this.$store.dispatch("exoprtCashOutList", searchCondition);
      setTimeout(() => {
        this.$message({
          message: "已加入导出队列正在生成报表，请在导出列队中查看！",
          type: "success",
        });
        this.hidden = false;
      }, 0);
    },
    queryList() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
      };

      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.starTime =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[0]
          : "";
      searchCondition.endTime =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[1]
          : "";
      Object.assign(params, searchCondition);
      return this.$store.dispatch("queryCashOutListV3", params);
    },
    queryAllList() {
      let params = {
        pageSize: 99999,
        pageNo: 1,
      };

      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.starTime =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[0]
          : "";
      searchCondition.endTime =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[1]
          : "";
      Object.assign(params, searchCondition);
      return this.$store.dispatch("queryAllCashOutListV3", params);
    },
    getChecked(selection) {
      // this.checkedRow = selection.map(v => v.spuId);
      this.checkedRow = selection;
    },
    /**
     * @desc 批量检查
     */
    async batchCheck() {
      console.log("---checkedRow---", this.checkedRow);
      if (!this.checkedRow.length) {
        return this.$message({
          message: "请选择",
          type: "warning",
        });
      }

      this.batchCheckTableData = [];
      let count = 0;
      let len = this.checkedRow.length;
      // for(let v of this.checkedRow) {
      this.dialogSettlementCompanyList(this.checkedRow[0].customerId)
      // this.checkedRow.forEach(async (v) => {
      for (let v of this.checkedRow){
        let customerInfo = [];
        let dataList0 = {};
        let check01 = true;
        let check02 = true;
        let check03 = true;
        let check04 = true;
        let check05 = true;
        let checkAll = true;
        let dynamicQueryCondition = {
          customerId: v.customerId,
        };
        let params = {
          dynamicQueryCondition: dynamicQueryCondition,
          reportCode: "customer_reconciliation_formula",
        };
        const { code, result } = await this.$store.dispatch(
          "queryCustomerInfo",
          params
        );
        if (result) {
          customerInfo = result;
          dataList0 = customerInfo.dataList[0];
          if (
            (dataList0.total_money_profit_amount || 0) ==
            ToFixed(
              (dataList0.allow_getcash_money_amount || 0) +
                (dataList0.being_getcash_money_amount || 0) +
                (dataList0.has_getcash_money_amount || 0) +
                (dataList0.unlock_money_amount || 0) +
                (dataList0.refund_money_amount || 0),
              2
            )
          ) {
            check01 = true;
            console.log("check01一致");
          } else {
            check01 = false;
            console.log("check01不一致");
          }
          if (
            (dataList0.flow3_input || 0) ==
            ToFixed(
              (dataList0.receipt_order_profit || 0) +
                (dataList0.video_ad || 0) +
                (dataList0.share_commission_amount || 0) +
                (dataList0.guider_recharge || 0) +
                (dataList0.other_profit || 0),
              2
            )
          ) {
            check02 = true;
            console.log("check02一致");
          } else {
            check02 = false;
            console.log("check02不一致");
          }
          if (
            (dataList0.all_out_amount || 0) ==
            ToFixed(
              (dataList0.get_cash_amount || 0) +
                (dataList0.guider_refund_amount || 0) +
                (dataList0.other_refund || 0),
              2
            )
          ) {
            check03 = true;
            console.log("check03一致");
          } else {
            check03 = false;
            console.log("check03不一致");
          }
          if (
            (dataList0.remainder || 0) ==
            ToFixed(
              (dataList0.onroad || 0) +
                (dataList0.allow_getcash_money_amount || 0),
              2
            )
          ) {
            check04 = true;
            console.log("check04一致");
          } else {
            check04 = false;
            console.log("check04不一致");
          }
          if (
            (dataList0.total_money_profit_amount || 0) ==
              (dataList0.flow3_input || 0) &&
            (dataList0.flow3_input || 0) ==
              ToFixed(
                (dataList0.all_out_amount || 0) + (dataList0.remainder || 0),
                2
              )
          ) {
            check05 = true;
            console.log("check05一致");
          } else {
            check05 = false;
            console.log("check05不一致");
          }
          if (check01 && check02 && check03 && check04 && check05) {
            checkAll = true;
          } else {
            checkAll = false;
          }
          v.checkAll = checkAll;
          v.isRegister = await this.getSettleAccounts(v)
          this.batchCheckTableData.push(v);
          // this.bbatchCheckTableData.push({
          //   isRegister:this.getSettleAccounts(v)
          // });
          count += 1;
          if (count === len) {
            this.batchCheckVisible = true;
            this.batchCheckTableData.sort((x, y) => {
              let xTime = Date.parse(x.getcachApplyTime);
              let yTime = Date.parse(y.getcachApplyTime);
              return xTime - yTime;
            });
          }
        }
      // });
      }
      // }
      console.log("batchCheckTableData", this.batchCheckTableData);
    },
    batchAgree() {
      if (this.checkedRow.length) {
        this.$confirm(`是否批量通过申请？`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          const searchCondition = JSON.parse(JSON.stringify(this.checkedRow));
          searchCondition.forEach((v) => {
            v.auditState = "agree";
          });

          this.$store
            .dispatch("batchOpertaeCashOutList", searchCondition)
            .then((res) => {
              if (res.code === "0") {
                this.$message({
                  message: "操作成功!",
                  type: "success",
                });
                setTimeout(() => {
                  this.resetRuleForm();
                }, 0);
                this.queryList();
              } else {
                this.queryList();
              }
            });
        });
      } else {
        this.$message({
          message: "请选择",
          type: "warning",
        });
      }
    },
    async showRemark(row, index=null) {
      if (index !== null) {
        this.handleBatch = false;
      }
      this.rowIndex = index;
      this.currentRow = row;
      await this.operatePreCheck();
      if (this.tipsTableList && this.tipsTableList.length) {
        this.dialogVisibleTips = true;
        console.log("有数据");
      } else {
        console.log("无数据");
        await this.operateLockGetcashSn("lock");
        this.dialogVisibleRemark = true;
        await this.querySettlementCompanyList(row.customerId);
        console.log("row.preAccount:", row.preAccount);
        if (row.preAccount) {
          this.ruleFormRemark.paymentAccount = row.preAccount;
          this.ruleFormRemark.agreeCert = "";
          this.ruleFormRemark.agreeRemark = "";
          this.spuSlideShowPicList = [];
          this.paymentAccountRow = row.preAccount;
          this.currentRowBankCard = {};
          console.log("this.bankCardList222:", this.bankCardList);
          this.bankCardList.forEach((v) => {
            if (v.id === row.preAccount) {
              this.paymentAccountSendNameRow = v.sendName;
              this.companyCode = v.companyCode;
              this.contractCompanyId = v.contractCompanyId;
              this.mchConfigId = v.id;
              this.companyName = v.companyName;
              this.currentRowBankCard = v;
            }
          });
        }
      }
    },
    async operatePreCheck() {
      this.tipsTableList = [];
      let params = {
        customerId: this.currentRow.customerId,
        auditState: "agree",
        createTime: this.currentRow.createTime,
      };
      const { code, result } = await this.$store.dispatch(
        "operatePreCheck",
        params
      );
      if (code === "0") {
        this.tipsTableList = result;
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.auditBank();
        }
      });
    },
    async auditBank() {
      const result = await this.$confirm(`是否通过申请？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      });
      if (result === "confirm") {
        if (!this.batchCheckVisible) {
          const searchCondition = JSON.parse(JSON.stringify(this.currentRow));
          searchCondition.auditState = "agree";
          if (searchCondition.getcashType === "bank") {
            if (
              this.spuSlideShowPicList &&
              this.spuSlideShowPicList.length > 0
            ) {
              this.ruleFormRemark.agreeCert = this.spuSlideShowPicList.toString();
            }
            Object.assign(searchCondition, this.ruleFormRemark);
          }
          console.log("---searchCondition---", searchCondition);

          this.$store
            .dispatch("opertaeCashOutListV3", searchCondition)
            .then((res) => {
              if (res.code === "0") {
                this.$message({
                  message: "操作成功!",
                  type: "success",
                });
                this.dialogVisibleRemark = false;
                this.dialogVisibleBill = false;
                this.operateLockGetcashSn("unLock");
                this.queryList();
              }
            });
        } else {
          if (this.batchCheckList && this.batchCheckList.length) {
            let count = 0;
            let len = this.batchCheckList.length;
            this.batchCheckList.forEach((v) => {
              const searchCondition = JSON.parse(JSON.stringify(v));
              searchCondition.auditState = "agree";
              if (searchCondition.getcashType === "bank") {
                if (
                  this.spuSlideShowPicList &&
                  this.spuSlideShowPicList.length > 0
                ) {
                  this.ruleFormRemark.agreeCert = this.spuSlideShowPicList.toString();
                }
                Object.assign(searchCondition, this.ruleFormRemark);
              }
              console.log("---searchCondition---", searchCondition);

              this.$store
                .dispatch("opertaeCashOutListV3", searchCondition)
                .then((res) => {
                  // if (res.code === "0") {
                  //   this.$message({
                  //     message: "操作成功!",
                  //     type: "success",
                  //   });
                  //   this.dialogVisibleRemark = false;
                  //   this.dialogVisibleBill = false;
                  //   this.operateLockGetcashSn("unLock");
                  //   this.queryList();
                  // }
                  count += 1;
                  if (count === len) {
                    this.$message({
                      message: "操作成功!",
                      type: "success",
                    });
                    this.dialogVisibleRemark = false;
                    this.dialogVisibleBill = false;
                    this.operateLockGetcashSn("unLock");
                    this.queryList();
                  }
                });
            });
          } else {
            this.$message.warning("请选择");
          }
        }
      }
    },
    async audit(row) {
      const result = await this.$confirm(`是否通过申请？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      });
      if (result === "confirm") {
        const searchCondition = JSON.parse(JSON.stringify(row));
        searchCondition.auditState = "agree";
        this.$store
          .dispatch("opertaeCashOutListV3", searchCondition)
          .then((res) => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功!",
                type: "success",
              });
              this.dialogVisibleBill = false;
              this.queryList();
            }
          });
      }
    },
    async updateWx() {
      let params = JSON.parse(JSON.stringify(this.currentRow));
      params.callbackOrderSn = this.wxDetails.detail_id;
      const { code } = await this.$store.dispatch("cashOutUpdate", params);
      if (code === "0") {
        this.$message({
          message: "操作成功!",
          type: "success",
        });
        this.dialogVisibleDetails = false;
        this.queryList();
      }
    },
    async details(row) {
      if (row.getcashType && row.getcashType === "wechat_v3") {
        this.$message({
          message: row.callbackMsg,
          type: "warning",
        });
        return;
      }
      this.currentRow = row;
      const { code, result } = await this.$store.dispatch("coinQueryMsg", row);
      if (code === "0") {
        this.wxDetails = result;
        this.dialogVisibleDetails = true;
      }
    },
    bill(row) {
      this.type = "daoGou";
      this.title = "个人账单";
      this.dialogVisibleBill = true;
      this.currentRow = row;
      console.log("this.currentRow:", this.currentRow);
      this.queryGuiderOrderList(this.currentRow);
      this.queryLastGuiderWhiteList(this.currentRow);
      this.$refs.HmGuiderBill.queryCustomerInfo(this.currentRow.customerId);
      // if (this.type === "daoGou") {

      //   this.queryGuiderOrderList(this.currentRow);
      // } else if (this.type === "fenXiao") {
      //   this.currentRow = row;
      //   this.queryShareOrderList(this.currentRow);
      // } else if (this.type === "withdraw") {
      // }
    },
    rechargeListPaging(page) {
      this.rechargePageNo = page;
      this.queryRechargeList(this.currentRow);
    },
    handleRechargeListSizeChange(size) {
      this.rechargePageNo = 1;
      this.rechargePageSize = size;
      this.queryRechargeList(this.currentRow);
    },
    shareListPaging(page) {
      this.shareOrderPageNo = page;
      this.queryShareOrderList(this.currentRow);
    },
    handleShareListSizeChange(size) {
      this.shareOrderPageNo = 1;
      this.shareOrderPageSize = size;
      this.queryShareOrderList(this.currentRow);
    },
    guiderPaging(page) {
      this.guiderCurrentPage = page;
      this.queryGuiderOrderList(this.currentRow);
    },
    handleGuiderSizeChange(size) {
      this.guiderCurrentPage = 1;
      this.guiderPageSize = size;
      this.queryGuiderOrderList(this.currentRow);
    },
    withDrawpaging(page) {
      this.withdrawCurrentPage = page;
      this.queryWithDrawOrderList(this.currentRow);
    },
    handleWithDrawSizeChange(size) {
      this.withdrawCurrentPage = 1;
      this.withdrawPageSize = size;
      this.queryShareOrderList(this.currentRow);
    },
    async queryWithDrawOrderList(row) {
      let params = {
        customerId: row.customerId,
        pageNo: this.withdrawCurrentPage,
        pageSize: this.withdrawPageSize,
      };
      let conditions = JSON.parse(JSON.stringify(this.withdrawConditions));
      if (conditions.getcachApplyTime && conditions.getcachApplyTime.length) {
        conditions.getcachApplyStartTime = conditions.getcachApplyTime[0];
        conditions.getcachApplyEndTime = conditions.getcachApplyTime[1];
        delete conditions.getcachApplyTime;
      }
      if (conditions.auditTime && conditions.auditTime.length) {
        conditions.auditStartTime = conditions.auditTime[0];
        conditions.auditEndTime = conditions.auditTime[1];
        delete conditions.auditTime;
      }
      Object.assign(params, conditions);
      // withdrawConditions
      const { result } = await this.$store.dispatch(
        "queryWithDrawOrderList",
        params
      );
      const { records, total } = result;
      this.widthDrawList = records;
      this.widthDrawListTotal = total;
    },
    submitReject(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.ruleForm.auditState = "refuse";
          const searchCondition = JSON.parse(JSON.stringify(this.ruleForm));
          const params = JSON.parse(JSON.stringify(this.rows));

          Object.assign(params, searchCondition);

          this.$store.dispatch("opertaeCashOutList", params).then((res) => {
            if (res.code === "0") {
              this.dialogVisible = false;
              this.dialogVisibleBill = false;
              if (this.rowIndex !== null) {
                this.$set(
                  this.batchCheckTableData[this.rowIndex],
                  "auditState",
                  "refuse"
                );
              }
              this.$message({
                message: "操作成功!",
                type: "success",
              });
              setTimeout(() => {
                this.resetRuleForm();
              }, 0);
              this.queryList();
            } else {
              this.queryList();
              this.dialogVisibleBill = false;
            }
          });
        } else {
          return false;
        }
      });
    },
    resetRuleForm() {
      this.$refs.ruleForm.resetFields();
      this.ruleForm.auditState = "";
      this.rejectReason = "";
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    load() {},
    toDetails(v) {
      this.$router.push({
        name: "WithdrawDetails",
      });
    },
    // 导出excel
    output() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        this.isOutputing = true;

        this.queryAllList()
          .then((res) => {
            let list = res.result.records;

            list.forEach((v, i) => {
              v.index = i + 1;
            });
            let tHeader = [
              "序号",
              "收款方支付宝账号",
              "收款方姓名",
              "金额(元)",
              "备注",
            ];

            let filterVal = [
              "index",
              "alipayAccount",
              "memberName",
              "getcashMoney",
              "xxxx",
            ];

            let title = "支付宝批量付款模板";

            let data = this.formatJson(filterVal, list);

            exportJsonToExcel(
              tHeader,
              data,
              title + new Date().toLocaleString()
            );
            this.isOutputing = false;
          })
          .catch(() => {
            this.isOutputing = false;
          });
      });
    },
    //导出银行卡提现
    outputBank() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        this.isOutputing = true;

        this.queryAllList()
          .then((res) => {
            let list = res.result.records;
            console.log("list1:", list);

            list.forEach((v, i) => {
              v.index = i + 1;
              if (v.bankInfo) {
                v.bankCardNumber = v.bankInfo.bankCardNumber;
                v.bankName = v.bankInfo.bankName;
              }
              if (v.auditState === "agree") {
                v.auditStateName = "通过";
              } else if (v.auditState === "wait") {
                v.auditStateName = "待审核";
              } else if (v.auditState === "refuse") {
                v.auditStateName = "驳回";
              }
              if (v.callbackStatus === "success") {
                v.callbackStatusName = "支付成功";
              } else if (v.callbackStatus === "fail") {
                v.callbackStatusName = "支付失败";
              }
            });
            console.log("list2:", list);
            let tHeader = [
              "序号",
              "状态",
              "提现单号",
              "会员姓名",
              "电话号码",
              "申请金额",
              "支付回执单号",
              "支付结果状态",
              "银行卡号",
              "银行",
              "预发账户",
              "身份证号",
              "申请时间",
              "审核时间",
              "审核人",
              "支付结果信息",
              "付款账号",
              "驳回备注",
            ];

            let filterVal = [
              "index",
              "auditStateName",
              "getcashSn",
              "memberName",
              "memberPhone",
              "getcashMoney",
              "callbackOrderSn",
              "callbackStatusName",
              "bankCardNumber",
              "bankName",
              "relPreAccount",
              "idcard",
              "getcachApplyTime",
              "auditTime",
              "auditUsername",
              "callbackMsg",
              "callbackReceiveAccount",
              "refuseReason",
            ];

            let title = "银行卡提现列表";

            let data = this.formatJson(filterVal, list);

            exportJsonToExcel(
              tHeader,
              data,
              title + new Date().toLocaleString()
            );
            this.isOutputing = false;
          })
          .catch(() => {
            this.isOutputing = false;
          });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    handleRemoves() {
      // this.spuSlideShowPicList = fileList.map(
      //   v => v.response && v.response.result
      // );
    },
    // 上传错误
    uploadError() {
      this.$message({
        message: "上传失败，请重试!",
        type: "warning",
      });
      this.isSaving = false;
    },
    cropUploadSuccesss(jsonData) {
      if (jsonData.code === 0) {
        // this.ruleForm.spuMainPic = jsonData.result;

        this.spuSlideShowPicList.push(jsonData.result);
        this.uploadShow = false;

        // setTimeout(() => {
        //   this.show = false;
        // }, 0);
      }
    },
    // 正在上传
    uploading() {
      this.isSaving = true;
      this.uploadShow = true;
    },
    handleRemoveListDetail(file) {
      if (typeof file === "number") {
        this.spuSlideShowPicList.splice(file, 1);
      } else {
        const index = this.spuSlideShowPicList.findIndex(
          (v) => v === file.response.result
        );
        this.spuSlideShowPicList.splice(index, 1);
      }
      console.log("this.spuSlideShowPicList:", this.spuSlideShowPicList);
    },
    // 上传前对文件的大小的判断
    beforeAvatarUpload(file) {
      const isUploadVideo =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "mp4";
      if (
        this.spuSlideShowPicList.find(
          (v) => v.indexOf(".mp4") > -1 || v.indexOf(".MP4") > -1
        ) &&
        isUploadVideo
      ) {
        this.$message({
          message: "仅支持上传一个视频",
          type: "warning",
        });
        return false;
      }
      const extension =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "jpg";
      const extension2 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() ===
        "jpeg";
      const extension3 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "png";
      const extension4 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "bmp";
      // file.size单位为b，除以1024得到kb
      // const limitSize = file.size / 1024 <= 100;
      if (
        !extension &&
        !extension2 &&
        !extension3 &&
        !extension4 &&
        !isUploadVideo
      ) {
        this.$message({
          message: "上传模板只能是 jpg、jpeg、png、bmp、mp4格式!",
          type: "warning",
        });
      }
      // if (!limitSize) {
      //   this.$message({
      //     message: "上传模板大小不能超过 100k!",
      //     type: "warning"
      //   });
      // }
      let isSize = true;
      if (!isUploadVideo) {
        isSize = new Promise((resolve, reject) => {
          // let width = 750;
          // let height = 750;
          let _URL = window.URL || window.webkitURL;
          let img = new Image();
          // img.onload = function() {
          //   let valid = img.width >= width && img.height >= height;
          //   valid ? resolve() : reject();
          // };
          img.src = _URL.createObjectURL(file);
          resolve();
        }).then(
          () => {
            return file;
          },
          () => {
            this.$message({
              message: "图片最低像素为（宽*高）：750*750",
              type: "warning",
            });
            return Promise.reject();
          }
        );
      } else {
        const limitSize = file.size / 1024 / 1024 <= 10;
        if (!limitSize) {
          this.$message({
            message: "上传视频大小不能超过10M!",
            type: "warning",
          });
          return false;
        }
      }
      return (
        (extension ||
          extension2 ||
          extension3 ||
          extension4 ||
          isUploadVideo) &&
        isSize
      );
    },
    async querySettlementCompanyList(customerId) {
      let params = {
        customerId,
      };
      const { result } = await this.$store.dispatch(
        "querySettlementCompanyList",
        params
      );
      this.bankCardList = result;
      console.log("this.bankCardList:", this.bankCardList);
    },
    async queryCustomerBankList(customerId) {
      let params = {
        customerId,
      };
      const { result } = await this.$store.dispatch(
        "queryCustomerBankList",
        params
      );
      this.bankRelList = result;
      console.log("this.bankRelList:", this.bankRelList);
    },
    paymentAccountChange(e) {
      console.log("e:", e);
      this.bankCardList.forEach((v) => {
        if (v.id === e) {
          this.paymentAccountSendName = v.sendName;
          this.companyCode = v.companyCode;
          this.contractCompanyId = v.contractCompanyId;
          this.mchConfigId = v.id;
          this.currentRowBankCard = v;
        }
      });
      console.log(this.companyCode);
    },
   async dialogSettlementCompanyList(customerId) {
      let params = {
        customerId,
      };
      const { result } = await this.$store.dispatch(
        "querySettlementCompanyList",
        params
      );
      this.dialogVisibleCardList = result;
      this.dialogVisiblePaymentAccount = result[0].id;
      // console.log("this.bankCardList:", this.bankCardList);
    },
    dialogPaymentAccountChange(e) {
      const updatedData = this.batchCheckTableData.map(async (v) => {
        const isRegister = await this.getSettleAccounts(v);
        return { ...v, isRegister };
      });

      Promise.all(updatedData).then((results) => {
        this.batchCheckTableData = results;
      });
      console.log("e:", this.batchCheckTableData);
    },
      async getSettleAccounts(row) {
      console.log(`已注册】判断值：procRegisterMode, row.customerId: ${row.customerId}, dialogVisiblePaymentAccount: ${this.dialogVisiblePaymentAccount}`);

      const params = {
        customerId: row.customerId,
      };

      let isRegister = false; // 默认为未注册状态

      try {
        const { result } = await this.$store.dispatch("querySettlementCompanyList", params);

        const matchedItem = result.find(v => v.id === this.dialogVisiblePaymentAccount);
        if (matchedItem) {
          isRegister = matchedItem.procRegisterMode === 'yes';
          console.log(`匹配到结算账户，procRegisterMode: ${matchedItem.procRegisterMode}, isRegister: ${isRegister}`);
        } else {
          console.warn('未找到匹配的结算账户');
        }
      } catch (error) {
        console.error('查询结算公司列表时发生错误:', error);
        // 可根据业务需求决定是否抛出异常
        // throw error;
      }

      return isRegister;
},
    async uploadWorkPlan(companyCode) {
      if (this.handleBatch) {
        let count = 0;
        for (let v of this.batchCheckList) {
        // this.batchCheckList.forEach((v) => {
          let params = {
            getcashSn: v.getcashSn,
            contractCompanyId: this.contractCompanyId,
            mchConfigId: this.mchConfigId,
            bizType: "redpackage",
            useScene: "settlement",
            customerId: v.customerId,
          };
          try {
            const res = await this.$store.dispatch("genSettlementRecord", params)
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.dialogVisibleRemark = false;
              if (this.rowIndex !== null) {
                this.$set(
                  this.batchCheckTableData[this.rowIndex],
                  "auditState",
                  "agree"
                );
              }
              this.operateLockGetcashSn("unLock");
              count += 1;
              if(count === this.batchCheckList.length) {
                this.search();
                this.handleBatch = false;
                this.batchCheckVisible = false;
              }
            }
          } catch(res) {
            console.log("catch---" + res.code);
            count += 1;
            if (res.code === "-888") {
              this.$store.dispatch("sendSetIpWhiteListSmsUniqueCode");
              this.dialogVisibleSmsCode = true;
            }
            if (count === this.batchCheckList.length) {
              this.search();
              this.handleBatch = false;
              this.batchCheckVisible = false;
            }
          }
        // })
        }
      } else {
        let params = {
          getcashSn: this.currentRow.getcashSn,
          contractCompanyId: this.contractCompanyId,
          mchConfigId: this.mchConfigId,
          bizType: "redpackage",
          useScene: "settlement",
          customerId: this.currentRow.customerId,
        };
        this.$store
          .dispatch("genSettlementRecord", params)
          .then((res) => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.dialogVisibleRemark = false;
              if (this.rowIndex !== null) {
                this.$set(
                  this.batchCheckTableData[this.rowIndex],
                  "auditState",
                  "agree"
                );
              }
              this.operateLockGetcashSn("unLock");
              this.search();
            }
          })
          .catch((res) => {
            console.log("catch---" + res.code);
            if (res.code === "-888") {
              this.$store.dispatch("sendSetIpWhiteListSmsUniqueCode");
              this.dialogVisibleSmsCode = true;
              return;
            }
          });
      }
    },
    async smsCodeRegain() {
      this.smsCodeRegainState = true;
      this.regainState = false;
      const { code, result } = await this.$store.dispatch(
        "sendSetIpWhiteListSmsUniqueCode"
      );
      if (code === "0") {
        this.smsCodeRegainState = false;
      }
    },
    smsCodeSubmit() {
      if (this.smsCode && this.smsCode.length !== 6) {
        this.$message({
          message: "验证码长度不足6位",
          type: "warning",
        });
        return;
      }
      this.$store
        .dispatch("checkSetIpWhiteListSmsUniqueCode", {
          smsCode: this.smsCode,
        })
        .then((res) => {
          this.dialogVisibleSmsCode = false;
        })
        .catch(() => {
          this.smsCode = "";
          this.regainState = true;
        });
    },
   
    // async queryWorkPlan(row){
    //   this.currentRow = row;
    //   let params = {
    //     updateMarkNo:row.hemiaoSettlementSn,
    //   };
    //   const { code,result } = await this.$store.dispatch(
    //     "thirdContractCustomerSettlementRecordQueryWorkPlan",
    //     params
    //   );
    //   if(code === '0'){
    //     this.dialogVisibleStatements = true;
    //     this.payStateDesc = result.payStateDesc;
    //     this.payFailReason = result.payFailReason;
    //   }
    // },
    // async getOldTaskInfo(row){
    //   this.currentRow = row;
    //   let params = {
    //     taskId: row.thirdExternalNo,
    //     thirdSettlementSn: row.thirdSettlementSn,
    //     hemiaoDetailSn: row.hemiaoDetailSn,
    //     hemiaoSettlementSn: row.hemiaoSettlementSn,
    //   };
    //   const { code,result } = await this.$store.dispatch(
    //     "thirdContractCustomerSettlementRecordGetOldTaskInfo",
    //     params
    //   );
    //   if(code === '0'){
    //     this.dialogVisibleStatements = true;
    //     this.payStateDesc = result.payStateDesc;
    //     this.payFailReason = result.payFailReason;
    //   }
    // },
    async getWechatBatchStatus(row) {
      this.currentRow = row;
      let params = {
        callbackOrderSn: row.callbackOrderSn,
      };
      console.log(999999);
      console.log(row);
      console.log(params);
      // 调取微信接口
      this.$store.dispatch("queryWechatBatchStatus", params).then((res) => {
        if (res.code === "0") {
          let status = res.result.status;
          console.log(res);
          console.log(status);
          if (status === "WAIT_PAY") {
            this.$message({
              message: "当前转账状态为待确认状态",
              type: "success",
            });
          } else if (status === "PROCESSING") {
            this.$message({
              message: "当前转账状态为转账中",
              type: "success",
            });
          } else if (status === "SUCCESS" || status === "FINISHED") {
            this.$message({
              message: "当前转账状态为转账成功",
              type: "success",
            });
          } else if (status === "FAIL") {
            this.$message({
              message: "当前转账状态为转账失败",
              type: "error",
            });
          }
        }
      });
    },
    async querySettlementRecord(row) {
      this.currentRow = row;
      let params = {
        customerId: row.customerId,
        companyCode: row.companyCode,
        contractCompanyId: row.contractCompanyId,
        hemiaoSettlementSn: row.hemiaoSettlementSn,
        hemiaoDetailSn: row.hemiaoDetailSn,
        thirdSettlementSn: row.thirdSettlementSn,
        thirdExternalNo: row.thirdExternalNo,
      };
      // 调取=银行接口
      const { code, result } = await this.$store.dispatch(
        "querySettlementRecord",
        params
      );
      if (code === "0" && result && Object.keys(result).length > 0) {
        this.payStateDesc = result.payStateDesc;
        this.payFailReason = result.payFailReason;
      }else { 
         this.payStateDesc = "";
         this.payFailReason = "";
      }
       this.dialogVisibleStatements = true;
        this.queryList();
    },
    async queryLastGuiderWhiteList(row) {
      this.guiderWhiteTips = "";
      let params = {
        guiderId: row.guiderId,
      };
      const { code, result } = await this.$store.dispatch(
        "queryLastGuiderWhiteList",
        params
      );
      if (result && result.operateMemo) {
        let operateMemo = JSON.parse(result.operateMemo);
        if (!operateMemo.isWhite) {
          this.guiderWhiteTips =
            "导购黑名单，原因：" +
            operateMemo.refuseReason +
            "！" +
            result.operateTime +
            " " +
            result.operateName;
          console.log("this.guiderWhiteTips:", this.guiderWhiteTips);
        }
      }
    },
    filterGt0OrFixed0(prop) {
      this[prop] = this[prop].replace(/^[^\d]+/g, "");
      this[prop] = this[prop].replace(".", "");
      this[prop] = this[prop].replace("-", "");
      this[prop] = this[prop].replace(",", "");
    },
    async operateLockGetcashSn(lockType) {
      let params = {
        getcashSn: this.currentRow.getcashSn,
        operateLock: lockType,
      };
      const { code, result } = await this.$store.dispatch(
        "operateLockGetcashSn",
        params
      );
    },
    async cancelDialogVisibleRemark() {
      await this.operateLockGetcashSn("unLock");
      this.handleBatch = false;
      this.dialogVisibleRemark = false;
    },
    async showForm2() {
      await this.queryCustomerBankList(this.currentRow.customerId);
      this.ruleForm2 = this.currentRowBankCard;
      this.ruleForm2.idcardName = this.currentRow.memberName;
      this.ruleForm2.authMobile = this.currentRow.memberPhone;
      this.ruleForm2.bankRelList = this.bankRelList;
      if (this.bankRelList && this.bankRelList.length === 1) {
        this.ruleForm2.bankRelId = this.bankRelList[0].id;
      }
      console.log("this.ruleForm2:", this.ruleForm2);
      this.docheckDialogVisible = true;
    },
    async submitForm2(formName) {
      if (!this.ruleForm2.bankRelId) {
        this.$message({
          message: "请选择银行卡",
          type: "warning",
        });
        return;
      }
      const isValid = await this.$refs[formName].validate();
      if (isValid) {
        if (!this.submitState) {
          this.submitState = true;
          this.doCheckCustomerIdentityElements();
        }
      }
    },
    async doCheckCustomerIdentityElements() {
      let params = {
        customerId: this.currentRow.customerId,
        bankRelId: this.ruleForm2.bankRelId,
        bankSaveMobile: this.ruleForm2.authMobile,
        contractCompanyId: this.ruleForm2.contractCompanyId,
      };
      console.log("params:", params);
      try {
        const { code, result } = await this.$store.dispatch(
          "doCheckCustomerIdentityElements",
          params
        );
        if (code === "0") {
           this.$message({
              message: result,
              type: "success",
            });
          await this.querySettlementCompanyList(this.currentRow.customerId);
          this.bankCardList.forEach((v) => {
            if (v.id === this.mchConfigId) {
              this.paymentAccountSendName = v.sendName;
              this.companyCode = v.companyCode;
              this.contractCompanyId = v.contractCompanyId;
              v.procRegisterMode = "no";
              this.currentRowBankCard = v;
            }
          });
          this.docheckDialogVisible = false;
        }
        this.submitState = false;
      } catch {
        this.submitState = false;
      }
    },
    cancel2() {
      this.docheckDialogVisible = false;
    },
    isBtn(code) {
      console.log(this.isShowBtn(code));
      return this.isShowBtn(code);
    },
    checkAllEvent(data) {
      this.checkAll = data;
      console.log("父组件this.checkAll:", this.checkAll);
    },
    handleBatchCheckSelectionChange(val) {
      console.log("---handleBatchCheckSelectionChange---", val);
      this.batchCheckList = val;
    },
    /**
     * @desc 点击行勾选checkbox
     */
    handleRowClick(row, column) {
      if (this.searchCondition.getcashType === "bank") {
        if (
          row.auditState === "wait" &&
          row.paymentStateDesc !== "拒绝发放" &&
          row.paymentStateDesc !== "打款失败" &&
          row.paymentStateDesc !== "打款中" &&
          row.paymentStateDesc !== "待打款" &&
          row.checkAll &&
          column.label !== "操作"
        ) {
          this.$refs.batchCheckTable.toggleRowSelection(row);
        }
      } else {
        if (row.auditState === "wait" && row.checkAll) {
          this.$refs.batchCheckTable.toggleRowSelection(row);
        }
      }
    },
    /**
     * @desc 批量通过
     */
    async handleBatchPass() {
      if (!this.batchCheckList.length) {
        return this.$message.warning("请选择");
      }
      if (this.searchCondition.getcashType === "bank") {
        // this.batchShowRemark();
        this.handleBatch = true
        this.showRemark(this.batchCheckList[0])
      } else {
        const result = await this.$confirm(`是否批量通过申请？`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });
        if (result === "confirm") {
          console.log("---batchCheckList---", this.batchCheckList);
          let count = 0;
          let len = this.batchCheckList.length;
          for(let v of this.batchCheckList) {
          // this.batchCheckList.forEach(async (v) => {
            const searchCondition = JSON.parse(JSON.stringify(v));
            searchCondition.auditState = "agree";
            try {
              await this.$store.dispatch("opertaeCashOutListV3", searchCondition);
              count += 1;
            } catch (error) {
              count += 1;
            }
            // count += 1;
            if (count === len) {
              this.$message({
                message: "操作成功!",
                type: "success",
              });
              this.dialogVisibleBill = false;
              this.batchCheckVisible = false;
              this.queryList();
            }
          // });
          }
        }
      }
    },
    async batchShowRemark() {
      // this.batchCheckList.forEach(v => {})

      console.log(this.batchCheckList);
      let row = this.batchCheckList[0];
      this.currentRow = row;
      await this.operatePreCheck();
      if (this.tipsTableList && this.tipsTableList.length) {
        this.dialogVisibleTips = true;
        console.log("有数据");
      } else {
        console.log("无数据");
        await this.operateLockGetcashSn("lock");
        this.dialogVisibleRemark = true;
        await this.querySettlementCompanyList(row.customerId);
        console.log("row.preAccount:", row.preAccount);
        if (row.preAccount) {
          this.ruleFormRemark.paymentAccount = row.preAccount;
          this.ruleFormRemark.agreeCert = "";
          this.ruleFormRemark.agreeRemark = "";
          this.spuSlideShowPicList = [];
          this.paymentAccountRow = row.preAccount;
          this.currentRowBankCard = {};
          console.log("this.bankCardList222:", this.bankCardList);
          this.bankCardList.forEach((v) => {
            if (v.id === row.preAccount) {
              this.paymentAccountSendNameRow = v.sendName;
              this.companyCode = v.companyCode;
              this.contractCompanyId = v.contractCompanyId;
              this.mchConfigId = v.id;
              this.companyName = v.companyName;
              this.currentRowBankCard = v;
            }
          });
        }
      }
    },
    /**
     * @desc 批量是否可勾选
     */
    selectableFn(row) {
      if (this.searchCondition.getcashType === "bank") {
        return (
          row.auditState === "wait" &&
          row.paymentStateDesc !== "拒绝发放" &&
          row.paymentStateDesc !== "打款失败" &&
          row.paymentStateDesc !== "打款中" &&
          row.paymentStateDesc !== "待打款" &&
          row.checkAll
        );
      } else {
        return row.auditState === "wait" && row.checkAll;
      }
    },
  },
};
</script>
<style lang="scss">
.sales-volumn-dialog {
  width: 800px;
}
@media screen and (max-width: 600px) {
  .sales-volumn-dialog {
    width: 320px;
  }
}
.reject-reason {
  .el-radio__label {
    white-space: normal;
    line-height: 24px;
  }
}
</style>
<style lang="scss" scoped>
.wx-details {
  > div {
    margin: 10px;
  }
}
.income {
  color: #e50065;
}
.title {
  width: 85px;
  text-align: right;
}
.modal-table {
  border: 1px solid rgba(221, 221, 221, 1);
  border-radius: 3px;
}
@media screen and (max-width: 414px) {
  .withdraw-container {
    .pc {
      display: none;
    }
    .mobile {
      display: block;
      margin: -10px;
      font-size: 14px;
      .list {
        background: #fff;
        .price {
          font-size: 16px;
        }
        .list-item {
          padding: 15px 15px 15px 0;
          margin-left: 15px;
          border-bottom: 1px solid #efefef;
          color: #999;
          line-height: 25px;
        }
        .count {
          color: #589dff;
        }
        .price {
          color: #f72b2b;
        }
        .tag {
          background: linear-gradient(
            180deg,
            rgba(112, 154, 247, 1),
            rgba(84, 135, 247, 1),
            rgba(43, 106, 247, 1)
          );
          color: #fff;
          font-size: 10px;
          border-radius: 30px;
          padding: 0 5px;
          margin-right: 5px;
        }
        .user-info {
          margin-right: 5px;
          color: #2b2b2b;
        }
      }

      .tabs {
        background: #fff;
        padding: 15px;
        margin-bottom: 10px;
        .tab {
          position: relative;
          &.active:after {
            content: "";
            position: absolute;
            bottom: -17px;
            left: 50%;
            width: 50%;
            transform: translateX(-50%);
            border-bottom: 4px solid #005ceb;
            border-radius: 30px;
          }
        }
      }

      .scroll-content {
        padding-bottom: 20px;
      }

      .control-panel {
        background: #fff;
        padding: 15px;
        border-bottom: 1px solid #f5f5f5;
        .ipt-wrapper {
          background: #f0f0f0;
          height: 34px;
          line-height: 34px;
          border-radius: 30px;
          border-bottom: 1px solid #f5f5f5;
          margin-right: 5px;
          padding-left: 10px;
          input {
            height: 34px;
            border: none;
            background: transparent;
            padding-left: 5px;
            font-size: 14px;
            &:focus {
              outline: none;
            }
          }
        }
      }

      .info {
        margin-top: 10px;
        line-height: 25px;
      }
    }
  }
}
@media screen and (min-width: 415px) {
  .withdraw-container {
    .pc {
      display: block;
    }

    .mobile {
      display: none;
    }
  }
}
.priview {
  position: relative;
  width: 100px;
  height: 100px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  img {
    width: 100%;
    height: 100%;
  }
  .video {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}

.form-tips {
  color: #e60e6d;
}
.statements-item {
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 10px;
}
.guiderWhiteTips {
  font-size: 16px;
}
.input-range {
  /deep/ .el-input-number {
    width: 100px;
    .el-input {
      width: 100%;
    }
  }
  .m-x5 {
    margin: 0 5px;
  }
}
.total-result {
  font-size: 16px;
  margin-bottom: 10px;
}
</style>
